module.exports = {
  path: 'history',
  childRoutes: [ require("./VineyardCreation"), require("./PlantingHistory") ]
}


// WEBPACK FOOTER //
// ./src/routes/History/index.js